import Button from "components/base/Button";
import { Input, Text } from "components/base/Form";
import { useState } from "react";

const EditBasicInfoView = ({ initialValues, saveHandler }) => {
  const [state, setState] = useState(initialValues);

  return (
    <div className=" space-y-6">
      <div className="-mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Name CN(中文名称): </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={state.nameCn}
                  onChange={(e) => {
                    setState({ ...state, nameCn: e.target.value });
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Size: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={state.size}
                  onChange={(e) => {
                    setState({ ...state, size: e.target.value });
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Weight(g): </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={state.weight}
                  onChange={(e) => {
                    setState({ ...state, weight: e.target.value });
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>HS Code: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={state.hsCode}
                  onChange={(e) => {
                    setState({ ...state, hsCode: e.target.value });
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Materials: </label>
              </td>
              <td>
                <Input
                  className="w-full"
                  value={state.materials}
                  onChange={(e) => {
                    setState({ ...state, materials: e.target.value });
                  }}
                />
              </td>
            </tr>

            <tr>
              <td>
                <label>Description: </label>
              </td>
              <td>
                <Text
                  value={state.description}
                  onChange={(e) => {
                    setState({ ...state, description: e.target.value });
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <Button primary onClick={() => saveHandler(state)}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default EditBasicInfoView;
